import { Mixins, Component, ProvideReactive } from "vue-property-decorator";
import AppCompose from "./components/appCompose.vue";
import GroupType from "./components/groupType.vue";

/**
 * README: appCompose 和 merchantAppCompose 共用的业务逻辑
 * 两个路由指向同一个组件文件，vue-name-loader 会生成相同的 name 导致 keep-alive 缓存冲突。
 * 提取 mixin 后，两个页面各自有独立组件 name，缓存互不干扰。
 */
@Component({
  components: { AppCompose, GroupType },
  inject: []
})
export default class AppComposeMixin extends Mixins() {
  @ProvideReactive() currentTab = "1";
  brandName = "";

  /**
   * README: 路由参数只在实例创建时读取一次。
   * 不要用 @Watch("$route")：$route 是全局响应式，keep-alive 缓存下切换 tab 会在
   * 中医大脑排版(appCompose)和品牌方APP排版(merchantAppCompose)两个实例上都触发，
   * 导致 brandName 互相污染。新实例 currentTab 默认即为 "1"，无需手动重置。
   */
  created() {
    const path = this.$route.path;
    if (["/appCompose", "/merchantAppCompose"].includes(path)) {
      this.brandName = <string>this.$route.query.brandName;
    }
  }
}
